export default __webpack_public_path__ + "static/media/include_14_male@3x.f7f06a0e.jpg";